module.exports = __webpack_public_path__ + "static/media/mobile_shops.08c60ed0.png";